import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
  Dimension__hashCode_impl_p583vw27ml4nzz2xkra as Dimension__hashCode_impl_p583vw,
} from './data.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DragDataClass;
function DragData() {
  if (DragDataClass === VOID) {
    class $ {
      static ecy(label, typeToData, dragShadow) {
        dragShadow = dragShadow === VOID ? null : dragShadow;
        var $this = createThis(this);
        $this.bcy_1 = label;
        $this.ccy_1 = typeToData;
        $this.dcy_1 = dragShadow;
        return $this;
      }
      static fcy(label, mimeType, data, dragShadow) {
        dragShadow = dragShadow === VOID ? null : dragShadow;
        return this.ecy(label, mapOf(to(mimeType, data)), dragShadow);
      }
      gi(mimeType) {
        return this.ccy_1.p3(mimeType);
      }
      gcy(label, typeToData, dragShadow) {
        return DragData().ecy(label, typeToData, dragShadow);
      }
      hcy(label, typeToData, dragShadow, $super) {
        label = label === VOID ? this.bcy_1 : label;
        typeToData = typeToData === VOID ? this.ccy_1 : typeToData;
        dragShadow = dragShadow === VOID ? this.dcy_1 : dragShadow;
        return $super === VOID ? this.gcy(label, typeToData, dragShadow) : $super.gcy.call(this, label, typeToData, dragShadow);
      }
      toString() {
        return 'DragData(label=' + this.bcy_1 + ', typeToData=' + toString(this.ccy_1) + ', dragShadow=' + toString_0(this.dcy_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.bcy_1);
        result = imul(result, 31) + hashCode(this.ccy_1) | 0;
        result = imul(result, 31) + (this.dcy_1 == null ? 0 : this.dcy_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DragData()))
          return false;
        if (!(this.bcy_1 === other.bcy_1))
          return false;
        if (!equals(this.ccy_1, other.ccy_1))
          return false;
        if (!equals(this.dcy_1, other.dcy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DragData');
    DragDataClass = $;
  }
  return DragDataClass;
}
var DragShadowClass;
function DragShadow() {
  if (DragShadowClass === VOID) {
    class $ {
      constructor(view, xAlign, yAlign, xOffset, yOffset) {
        xAlign = xAlign === VOID ? Align_Center_getInstance() : xAlign;
        yAlign = yAlign === VOID ? Align_Center_getInstance() : yAlign;
        xOffset = xOffset === VOID ? null : xOffset;
        yOffset = yOffset === VOID ? null : yOffset;
        this.icy_1 = view;
        this.jcy_1 = xAlign;
        this.kcy_1 = yAlign;
        this.lcy_1 = xOffset;
        this.mcy_1 = yOffset;
      }
      toString() {
        var tmp = this.icy_1.toString();
        var tmp_0 = this.jcy_1.toString();
        var tmp_1 = this.kcy_1.toString();
        var tmp_2 = this.lcy_1;
        var tmp_3 = toString_0(tmp_2 == null ? null : new (Dimension())(tmp_2));
        var tmp_4 = this.mcy_1;
        return 'DragShadow(view=' + tmp + ', xAlign=' + tmp_0 + ', yAlign=' + tmp_1 + ', xOffset=' + tmp_3 + ', yOffset=' + toString_0(tmp_4 == null ? null : new (Dimension())(tmp_4)) + ')';
      }
      hashCode() {
        var result = hashCode(this.icy_1);
        result = imul(result, 31) + this.jcy_1.hashCode() | 0;
        result = imul(result, 31) + this.kcy_1.hashCode() | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.lcy_1;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = Dimension__hashCode_impl_p583vw(this.lcy_1);
        }
        result = tmp + tmp_0 | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.mcy_1;
        if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = Dimension__hashCode_impl_p583vw(this.mcy_1);
        }
        result = tmp_2 + tmp_3 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DragShadow()))
          return false;
        if (!equals(this.icy_1, other.icy_1))
          return false;
        if (!this.jcy_1.equals(other.jcy_1))
          return false;
        if (!this.kcy_1.equals(other.kcy_1))
          return false;
        var tmp = this.lcy_1;
        var tmp_0 = tmp == null ? null : new (Dimension())(tmp);
        var tmp_1 = other.lcy_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (Dimension())(tmp_1)))
          return false;
        var tmp_2 = this.mcy_1;
        var tmp_3 = tmp_2 == null ? null : new (Dimension())(tmp_2);
        var tmp_4 = other.mcy_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (Dimension())(tmp_4)))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DragShadow');
    DragShadowClass = $;
  }
  return DragShadowClass;
}
var DragEventClass;
function DragEvent() {
  if (DragEventClass === VOID) {
    class $ {
      constructor(data, xInView, yInView) {
        this.ncy_1 = data;
        this.ocy_1 = xInView;
        this.pcy_1 = yInView;
      }
      toString() {
        return 'DragEvent(data=' + this.ncy_1.toString() + ', xInView=' + this.ocy_1 + ', yInView=' + this.pcy_1 + ')';
      }
      hashCode() {
        var result = this.ncy_1.hashCode();
        result = imul(result, 31) + getNumberHashCode(this.ocy_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.pcy_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DragEvent()))
          return false;
        if (!this.ncy_1.equals(other.ncy_1))
          return false;
        if (!equals(this.ocy_1, other.ocy_1))
          return false;
        if (!equals(this.pcy_1, other.pcy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DragEvent');
    DragEventClass = $;
  }
  return DragEventClass;
}
//region block: exports
export {
  DragData as DragData2helsigoeiabk,
  DragEvent as DragEventn7vmft816tmz,
  DragShadow as DragShadow11keb9piinnfw,
};
//endregion

//# sourceMappingURL=DragData.mjs.map
